const formatTitle = {
  creation: 'Creación',
  changeStatusTrue: 'Inactivado',
  changeStatusFalse: 'Reativado',
  changeMaintenanceStatusTrue: 'Retorno de mantenimiento',
  changeMaintenanceStatusFalse: 'Enviado para mantenimiento',
  changeEquipmentModel: 'Actualización del tipo de equipo',
  changeCompany: 'Actualización de la empresa',
  changeReference: 'Actualización de la referencia',
  changeSerialNumber: 'Actualización del número de serie',
  changeDescription: 'Actualización de las especificaciones',
  changePlace: 'Actualización del sitio',
  changeSite: 'Actualización del sitio',
  changePhoto: 'Actualización de la Foto',
  changeBrand: 'Actualización de la marca del equipo',
  changeCompanies: 'Actualización de las empresas',
  default: 'Este equipo fue actualizado'
};

export default formatTitle;
